import Keycloak from "keycloak-js";
import { computed, ref } from "vue";

const initOptions = {
    url: window._env_.KEYCLOAK_API_ENDPOINT,
    realm: window._env_.KEYCLOAK_REALM,
    clientId: window._env_.KEYCLOAK_CLIENT_ID,
};

const token = ref(null);
const tokenParsed = ref(null);

export const auth = {
    isAuthenticated: computed(() => token.value !== null),
    token,
    tokenParsed,
    logout() {
        token.value = null;
        tokenParsed.value = null;
        keycloak.logout({
            redirectUri: window._env_.KEYCLOAK_LOGOUT_REDIRECT_URI
                ? window._env_.KEYCLOAK_LOGOUT_REDIRECT_URI
                : window.location.origin,
        });
    },
    isStaff: computed(
        () =>
            tokenParsed.value &&
            tokenParsed.value.unilMemberOf &&
            window._env_.STAFF_GROUPS.split(",").some(group => tokenParsed.value.unilMemberOf.includes(group.trim()))
    ),
    fullName: computed(() => {
        if (tokenParsed.value && tokenParsed.value.givenName && tokenParsed.value.surname) {
            return `${tokenParsed.value.givenName} ${tokenParsed.value.surname.toUpperCase()}`;
        }
        return "";
    }),
};

export const keycloak = new Keycloak(initOptions);
keycloak.onAuthSuccess = () => {
    token.value = keycloak.token;
    tokenParsed.value = keycloak.tokenParsed;
};
keycloak.onAuthRefreshSuccess = () => {
    token.value = keycloak.token;
    tokenParsed.value = keycloak.tokenParsed;
};
keycloak.onTokenExpired = () => {
    keycloak
        .updateToken(5)
        .then(refreshed => {
            if (refreshed) {
                token.value = keycloak.token;
                tokenParsed.value = keycloak.tokenParsed;
            }
        })
        .catch(() => {
            token.value = null;
        });
};
keycloak.onAuthError = () => {
    token.value = null;
};
keycloak.onAuthLogout = () => {
    token.value = null;
};
